<script setup lang="ts">
import type { ThemeSettings } from '~/stores/auth'
import { useCardHover } from '~/composables/useCardHover'

const props = defineProps<{
  label: string
  icon: string
  cardStyle?: Record<string, string>
  themeSettings?: ThemeSettings
}>()

const { onCardMouseMove, onCardMouseLeave } = props.themeSettings
  ? useCardHover(toRef(props, 'themeSettings') as Ref<ThemeSettings>)
  : { onCardMouseMove: undefined, onCardMouseLeave: undefined }
</script>

<template>
  <!-- With cardStyle: standalone card (used in layouts where embeds are their own cards) -->
  <div
    v-if="cardStyle"
    class="rounded-xl overflow-hidden p-5"
    :style="cardStyle"
    @mousemove="onCardMouseMove"
    @mouseleave="onCardMouseLeave"
  >
    <div class="flex flex-col items-center gap-3 py-4 text-white/30">
      <UIcon
        :name="icon"
        class="size-8"
      />
      <span class="text-xs font-medium uppercase tracking-wider">
        {{ label }}
      </span>
      <div class="w-full space-y-2 mt-2">
        <div class="h-3 rounded-full bg-white/8 w-3/4 mx-auto" />
        <div class="h-3 rounded-full bg-white/8 w-1/2 mx-auto" />
        <div class="h-3 rounded-full bg-white/8 w-2/3 mx-auto" />
      </div>
    </div>
  </div>
  <!-- Without cardStyle: inline section inside an existing card -->
  <div
    v-else
    class="w-full mt-6 py-6 border-t border-white/5"
  >
    <div class="flex flex-col items-center gap-3 text-white/30">
      <UIcon
        :name="icon"
        class="size-8"
      />
      <span class="text-xs font-medium uppercase tracking-wider">
        {{ label }}
      </span>
      <div class="w-full space-y-2 mt-2">
        <div class="h-3 rounded-full bg-white/8 w-3/4 mx-auto" />
        <div class="h-3 rounded-full bg-white/8 w-1/2 mx-auto" />
        <div class="h-3 rounded-full bg-white/8 w-2/3 mx-auto" />
      </div>
    </div>
  </div>
</template>
